




















import { Component, Prop, Vue } from "vue-property-decorator";
import CustomChart, { CustomChartItem } from "./CustomChart.vue";

@Component({
  components: {
    CustomChart,
  },
})
export default class PieChart extends Vue {
  @Prop({ default: () => [] }) readonly labels!: string[];
  @Prop({ required: true }) readonly items!: CustomChartItem[];
  @Prop({ default: "pie" }) readonly type?: string;
  @Prop({ default: false }) readonly stacked?: boolean;
  @Prop({ default: false }) readonly multilevel!: boolean;
  @Prop({ default: false }) readonly hideSublevelLabels!: boolean;
}
